import { createStore } from 'vuex'
import config from '@/store/modules/config.js'
import form from '@/store/modules/form.js'
import kwis from '@/store/modules/kwis.js'
import network from '@/store/modules/network.js'
import notification from '@/store/modules/notification.js'
import time from '@/store/modules/time.js'

export default createStore({
  modules: {
    config: config,
    form: form,
    kwis: kwis,
    network: network,
    notification: notification,
    time: time,
  },
})
